var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "evolucao" },
    [
      _vm.modoGrafico === "rentabilidade"
        ? _c("PortfolioBenchmark", {
            attrs: {
              data: _vm.dataRentabilidade,
              loading: _vm.loading,
              "has-assets-automatic": _vm.hasAssetsAutomatic,
              value: _vm.benchmarksSelecionados,
              benchmarks: _vm.benchmarks,
              "cliente-benchmark-meta": _vm.clienteBenchmarkMeta,
              "available-benchmark-names": _vm.availableBenchmarkNames,
              "show-add-benchmark": _vm.showAddBenchmark,
              "hide-benchmarks": _vm.hideBenchmarks
            },
            on: {
              input: function($event) {
                return _vm.$emit("update:benchmarks-selecionados", $event)
              },
              change: function($event) {
                return _vm.$emit("change")
              },
              "add-benchmark": function($event) {
                return _vm.$emit("add-benchmark")
              },
              reset: function($event) {
                return _vm.$emit("reset")
              },
              "update:showAllGroups": function($event) {
                _vm.showAllGroups = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "actions-left",
                  fn: function() {
                    return [
                      _c("ViewModeToggle", {
                        attrs: {
                          options: _vm.toggleOptions,
                          disabled: _vm.loading
                        },
                        model: {
                          value: _vm.modoGrafico,
                          callback: function($$v) {
                            _vm.modoGrafico = $$v
                          },
                          expression: "modoGrafico"
                        }
                      }),
                      _vm.hasAssetsAutomatic
                        ? _c(
                            "v-tooltip",
                            {
                              staticClass: "evolucao__assets-automatic",
                              attrs: { bottom: "", "max-width": "360" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "icon-svg",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  name: "mdi-information",
                                                  size: 12
                                                }
                                              },
                                              "icon-svg",
                                              attrs,
                                              false
                                            ),
                                            on
                                          )
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3225776141
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " A rentabilidade do portfólio XP é calculada automaticamente. "
                                ),
                                _c("br"),
                                _vm._v(
                                  " Para ver a rentabilidade de cada produto, adicione as informações faltantes e os aportes/resgates dele. "
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions-right",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "evolucao__ampliar" },
                        [
                          _c(
                            "BaseModal",
                            {
                              attrs: {
                                "max-width": "95%",
                                "destroy-on-close": ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button",
                                    fn: function() {
                                      return [
                                        _c(
                                          "BaseButton",
                                          {
                                            attrs: {
                                              disabled: _vm.loading,
                                              secondary: "",
                                              text: "",
                                              sm: ""
                                            }
                                          },
                                          [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: "mdi-fullscreen",
                                                size: 16,
                                                color: "primary"
                                              }
                                            }),
                                            _vm._v(" Ampliar ")
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                831185762
                              )
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("SectionTitle", {
                                    attrs: { title: "Portfólio e Benchmark" }
                                  }),
                                  _c("RentabilidadeChart", {
                                    staticClass: "evolucao__ampliar-chat",
                                    attrs: { data: _vm.displayedRentabilidade }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2337627857
            )
          })
        : _vm._e(),
      _vm.modoGrafico === "patrimonio"
        ? _c("EvolucaoPatrimonial", {
            attrs: {
              data: _vm.dataPatrimonio,
              loading: _vm.loading,
              "investment-type": _vm.investmentType
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "actions-left",
                  fn: function() {
                    return [
                      _c("ViewModeToggle", {
                        attrs: {
                          options: _vm.toggleOptions,
                          disabled: _vm.loading
                        },
                        model: {
                          value: _vm.modoGrafico,
                          callback: function($$v) {
                            _vm.modoGrafico = $$v
                          },
                          expression: "modoGrafico"
                        }
                      })
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions-right",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "evolucao__ampliar" },
                        [
                          _c(
                            "BaseModal",
                            {
                              attrs: {
                                "max-width": "95%",
                                "destroy-on-close": ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button",
                                    fn: function() {
                                      return [
                                        _c(
                                          "BaseButton",
                                          {
                                            attrs: {
                                              disabled: _vm.loading,
                                              secondary: "",
                                              text: "",
                                              sm: ""
                                            }
                                          },
                                          [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: "mdi-fullscreen",
                                                size: 16,
                                                color: "primary"
                                              }
                                            }),
                                            _vm._v(" Ampliar ")
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                831185762
                              )
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("SectionTitle", {
                                    attrs: { title: "Evolução Patrimonial" }
                                  }),
                                  _c("PatrimonioChart", {
                                    staticClass: "evolucao__ampliar-chat",
                                    attrs: {
                                      data: _vm.dataPatrimonio,
                                      investmentType: _vm.investmentType
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2023424167
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }